import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function Career() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>
                          {" "}
                          NEW RANGE OF PHARMA FORMULATION FOR TRADE SALES
                        </h2>
                        <div class="row ">
                          <div class="col-sm-6">
                            <img src="../images/pharma-formulation.jpg" />
                          </div>
                        </div>
                        <p style={{ marginTop: "15px", paddingRight: "140px" }}>
                          Earlier, IDPL was a well known name in Trade Sales of
                          Pharmaceutical Formulations. IDPL is going to
                          re-launched into Trade Sales by engaging franchisees.
                          About 50 formulations, which include its products
                          latest prescription molecules in Injectable, Oral and
                          Topical forms, have been selected including well known
                          brands of IDPL, like Sukcee (vitamin C chewable
                          tablets), Idicin (Indomethacin), Cebexin tablets
                          (vitamin B with vitamin C). They cover wide range of
                          therapeutic segments like Oral Antibiotics/
                          Antimicrobials, Dry Syrups, Antibiotic Injections,
                          Anti-Inflammatory / Analgesics / Muscle Relaxant /
                          Anti-Arthritic, Cardio-Vasculars , Antacid /
                          Anti-Ulcerative, Neuro-Care, Anti-Diabetic,
                          Anti-Oxidant, Vitamins/ Minerals/ Nutritional
                          Supplements, Cough Syrup / Antitussive etc.{" "}
                        </p>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
